import { apiSlice } from '../apiSlice';
import {
	MomentDetailDTO,
	MomentDetailExerciseDto,
	MomentDetailPageDTO,
	MomentDetailPageFilter,
	MomentPageDTO,
	MomentPageFilter,
} from '../DTO/app-setting/moment.interface';
import { SuccessResponse, Paginated } from '../DTO/common.interface';

export const momentApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getMomentList: builder.query<
			SuccessResponse<Paginated<MomentPageDTO>>,
			MomentPageFilter
		>({
			query: (body) => ({
				url: `/web/need-now/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['MomentList'],
		}),
		sortMomentList: builder.mutation<
			SuccessResponse<any>,
			{ sortList: { sort: number; id: string }[] }
		>({
			query: (body) => ({
				url: `/web/need-now/sort`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['MomentList'],
		}),
		createMoment: builder.mutation<
			SuccessResponse<any>,
			{ id?: string; titleEn: string; titleZh: string }
		>({
			query: (body) => ({
				url: `/web/need-now`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['MomentList'],
		}),
		updateMoment: builder.mutation<SuccessResponse<any>, MomentDetailDTO>({
			query: (body) => ({
				url: `/web/need-now`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['MomentDetail'],
		}),
		getMomentDetail: builder.query<SuccessResponse<MomentDetailDTO>, string>({
			query: (id) => ({
				url: `/web/need-now/${id}`,
				method: 'GET',
			}),
			providesTags: ['MomentDetail'],
		}),
		deleteMoment: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/need-now/${id}`,
				method: 'DELETE',
			}),
		}),
		getMomentDetailList: builder.query<
			SuccessResponse<Paginated<MomentDetailPageDTO>>,
			MomentDetailPageFilter
		>({
			query: (body) => ({
				url: `/web/need-now-exercise/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['MomentDetailList'],
		}),
		getMomentDetailExerciseList: builder.query<
			SuccessResponse<Paginated<MomentDetailPageDTO>>,
			MomentDetailPageFilter
		>({
			query: (body) => ({
				url: `/web/need-now-exercise/exercise/page`,
				method: 'POST',
				body,
			}),
		}),
		createMomentDetailExercise: builder.mutation<
			SuccessResponse<any>,
			MomentDetailExerciseDto
		>({
			query: (body) => ({
				url: `/web/need-now-exercise/${body.needNowId}/exercise`,
				method: 'POST',
				body: body.exerciseIds,
			}),

			invalidatesTags: ['MomentDetailList'],
		}),
		deleteMomentDetailExercise: builder.mutation<
			SuccessResponse<any>,
			string[]
		>({
			query: (body) => ({
				url: `/web/need-now-exercise/batch`,
				method: 'DELETE',
				body,
			}),

			invalidatesTags: ['MomentDetailList'],
		}),
		setMomentDetailExerciseSort: builder.mutation<
			SuccessResponse<any>,
			{ sortList: { sort: number; id: string }[] }
		>({
			query: (body) => ({
				url: `/web/need-now-exercise/sort`,
				method: 'POST',
				body,
			}),

			invalidatesTags: ['MomentDetailList'],
		}),
	}),
});

export const {
	useGetMomentListQuery,
	useSortMomentListMutation,
	useCreateMomentMutation,
	useUpdateMomentMutation,
	useGetMomentDetailQuery,
	useDeleteMomentMutation,
	useGetMomentDetailListQuery,
	useGetMomentDetailExerciseListQuery,
	useCreateMomentDetailExerciseMutation,
	useDeleteMomentDetailExerciseMutation,
	useSetMomentDetailExerciseSortMutation,
} = momentApiSlice;
